export default {
  meta: {
    title: '选址地图-热力',
    url: '/sitemap/heatmap', // 埋点字段，上报归属的模块
    urlName: '选址地图-热力' // 埋点字段，上报归属的模块
  }
};
